export { FullWidthImage as default } from "@ecologi/react-components/src/FullWidthImage";
